import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import * as React from 'react';

import { defaultGuardDescription, NavigationGuardRoot, usePendingNavigation } from '../../routing/NavigationGuard';
import { DestructivePrimaryButton, SecondaryButton } from '../buttons';
import { Dialog } from '../Dialog/Dialog';
import { DialogActions } from '../Dialog/DialogActions';
import { DialogContent } from '../Dialog/DialogContent';
import { DialogTitle } from '../Dialog/DialogTitle';
import { Text } from '../Text';

/** The navigation guard with its dialog. Mount once, inside the router; the dialog needs theme and i18n. */
export function NavigationGuardProvider({ children }: { children?: React.ReactNode }): JSX.Element {
    return (
        <NavigationGuardRoot>
            {children}
            <PendingNavigationDialog />
        </NavigationGuardRoot>
    );
}

function PendingNavigationDialog(): JSX.Element {
    const pending = usePendingNavigation();

    return (
        <Dialog maxWidth="xs" open={pending !== null} onClose={() => pending?.resolve(false)}>
            <DialogTitle title={pending?.copy.title ?? t`Unsaved changes`} onClose={() => pending?.resolve(false)} />
            <DialogContent>
                <Text>{pending?.copy.description ?? defaultGuardDescription()}</Text>
            </DialogContent>
            <DialogActions>
                <SecondaryButton autoFocus size="medium" onClick={() => pending?.resolve(false)}>
                    {pending?.copy.cancelLabel ?? <Trans>Stay on this page</Trans>}
                </SecondaryButton>
                <DestructivePrimaryButton size="medium" onClick={() => pending?.resolve(true)}>
                    {pending?.copy.confirmLabel ?? <Trans>Leave page</Trans>}
                </DestructivePrimaryButton>
            </DialogActions>
        </Dialog>
    );
}
